import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import DocketParts from '../docket/docketEntries/Documents';
import LoadingBar from '../../common/LoadingBar';
import loadingBarImage from '../../../images/loadingBar.gif';


const RelatedTransactionEntries = (props) => {
  const {
    transactions,
    getDocketDetails,
    reloadDetails,
    buyPdf,
    onPopupClick,
    case_uuid,
    selectedDocketDetailNum,
    sortRelatedTransaction,
    entries,
    tableSortProps,
  } = props;

  const { docketDetails = {} } = transactions;
  const getClassName = index => (index % 2 === 0 ? 'even' : 'odd');
  const sortIconsFA = {
    asc: 'fa-sort-up',
    desc: 'fa-sort-down',
  };
  let itemRows = null;

  if (_.isEmpty(entries)) {
    itemRows = <tr><td colSpan="4">No Transactions found.</td></tr>;
  } else {
    itemRows = entries.reduce((accum, p, idx) => {
      const key = `docket-entry-${idx}`;

      const { text, meta } = p;

      const colorClasses = {
        0: 'in-pacer',
        1: 'in-inforuptcy',
        2: 'purchased',
      };
      const docketNumLink = (!text.docket_uri)
        ? (text.docket_no || null)
        : (
          <div className={`view_details ${colorClasses[meta.purchased || 0]}`}
           onClick={getDocketDetails.bind(null, text.docket_no, `${idx}`)}>
            <strong> {text.docket_no || null} </strong>
          </div>
        );
      const docketRelatedNumLink = (docket_no, mainIndex, relatedIndex) =>
        <div className={`view_details-related ${colorClasses[meta.purchased || 0]}`}
           onClick={getDocketDetails.bind(null, docket_no, `${mainIndex}-${relatedIndex}`)}>
          <strong> {docket_no || null} </strong>
        </div>;
      let relatedTransactions = {};

      if (text.related) {
        const relatedDetailResults = (item, keyValue) => (docketDetails.seqNum && docketDetails.seqNum === item.docket_no && props.visibleDocketRow === `${idx}-${keyValue}`);
        const relatedDetailLoadingBar = (item, keyValue) => (relatedDetailResults(item, keyValue) ?
          false :
          (selectedDocketDetailNum === item.order_docket_seq || (selectedDocketDetailNum === item.docket_no && item.docket_no != null)) && props.visibleDocketRow === `${idx}-${keyValue}`);

        const relatedTransactionsParts = (docketDetails.seqNum && docketDetails.details.length === 0)
          ? (
            <tr key={`details-${key}`} className={`${getClassName(idx)} docket_details`}>
              <td colSpan="2" />
              <td className="here" colSpan="100%">No Accessible Documents Found</td>
            </tr>
          ) : (
            <tr key={`details-${key}`} className={`${getClassName(idx)} docket_details`}>
              <td colSpan="2" />
              <td className="here" colSpan="100%">
                <table className="sticky-enabled">
                  <thead>
                    <tr>
                      <th />
                      <th>Part</th>
                      <th>Description</th>
                      <th>Pages</th>
                      <th width="50%">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <DocketParts docketDetails={docketDetails}
                      buyPdf={buyPdf}
                      onPopupClick={onPopupClick}
                      case_uuid={case_uuid}
                      docket_number={docketDetails.seqNum}
                      reloadDetails={reloadDetails} />
                    {/* TODO: update component
                    <DocketParts documents={binder.documents}
                                 case_uuid={case_uuid}
                                 court_code={court_code}
                                 case_number={case_number}
                                 docket_seq={docket_seq}
                                 reloadDetails={reloadDetails} />*/}
                  </tbody>
                </table>
              </td>
            </tr>);

        relatedTransactions = text.related.map((item, keyValue) =>
          <React.Fragment>
            <tr colSpan="5" key={keyValue} className={`${getClassName(idx)} details-visible heading`}>
              <td align="right" colSpan="2">{docketRelatedNumLink(item.docket_no, idx, keyValue)}</td>
              <td style={{ paddingLeft: '7px' }}>
                <span dangerouslySetInnerHTML={{ __html: item.event_name }} />
                { relatedDetailLoadingBar(item, keyValue) ? <LoadingBar overrideShow /> : null }
              </td>
              <td style={{ textAlign: 'center' }}>{ item.date_event_filed || '' }</td>
              <td style={{ textAlign: 'center' }}>{ item.date_event_terminated || '' }</td>
            </tr>
            { relatedDetailResults(item, keyValue) ? relatedTransactionsParts : null }
          </React.Fragment>);
      }

      if (docketDetails.seqNum && docketDetails.seqNum === text.docket_no && props.visibleDocketRow === `${idx}`) {
        accum.push((
          <React.Fragment>
            <tr key={key} className={`${getClassName(idx)} details-visible heading`}>
              <td colSpan="2">
                { docketNumLink }
              </td>
              <td>
                <strong><span dangerouslySetInnerHTML={{ __html: text.event_name }} /></strong>
                { docketDetailLoadingBar }
              </td>
              <td style={{ textAlign: 'center' }} >{text.date_event_filed}</td>
              <td style={{ textAlign: 'center' }} >{text.date_event_terminated}</td>
            </tr>
          </React.Fragment>
        ));

        if (docketDetails.details.length === 0) {
          accum.push((
            <tr key={`details-${key}`} className={`${getClassName(idx)} docket_details`}>
              <td colSpan="2" />
              <td className="here" colSpan="100%">No Accessible Documents Found</td>
            </tr>
          ));
        } else {
          accum.push((
            <tr key={`details-${key}`} className={`${getClassName(idx)} docket_details`}>
              <td colSpan="2" />
              <td className="here" colSpan="100%">
                <table className="sticky-enabled">
                  <thead>
                    <tr>
                      <th />
                      <th>Part</th>
                      <th>Description</th>
                      <th>Pages</th>
                      <th width="50%">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <DocketParts docketDetails={docketDetails}
                                 buyPdf={buyPdf}
                                 case_uuid={case_uuid}
                                 docket_number={docketDetails.seqNum}
                                 reloadDetails={reloadDetails} />
                    {/* TODO: update component
                    <DocketParts documents={binder.documents}
                                 case_uuid={case_uuid}
                                 court_code={court_code}
                                 case_number={case_number}
                                 docket_seq={docket_seq}
                                 reloadDetails={reloadDetails} />*/}
                  </tbody>
                </table>
              </td>
            </tr>
          ));
        }
        accum.push(relatedTransactions);

        return accum;
      }

      const docketDetailLoadingBar = (selectedDocketDetailNum === text.order_docket_seq || (selectedDocketDetailNum === text.docket_no && text.docket_no != null)) && props.visibleDocketRow === `${idx}`
        ? <LoadingBar overrideShow />
        : null;

      accum.push((
        <React.Fragment>
          <tr key={key} className={`${getClassName(idx)} details-visible heading`}>
            <td colSpan="2" style={{ textAlign: 'center' }} >
              { docketNumLink }
            </td>
            <td>
              <strong><span dangerouslySetInnerHTML={{ __html: text.event_name }} /></strong>
              { docketDetailLoadingBar }
            </td>
            <td style={{ textAlign: 'center' }} >{text.date_event_filed}</td>
            <td style={{ textAlign: 'center' }} >{text.date_event_terminated}</td>
          </tr>
        </React.Fragment>
      ));
      accum.push(relatedTransactions);
      return accum;
    }, []);
  }

  return (
    <div id="ir-search-related-transactions-results">
      <table>
        <thead>
          <tr>
            <th style={{ textAlign: 'center', minWidth: '60px' }} colSpan="2">
              <div className="item" onClick={sortRelatedTransaction.bind(null, 'docket_no')}>#
                {tableSortProps.sort_field === 'docket_no' ? <i className={`fa ${sortIconsFA[tableSortProps.sort_direction]}`} /> : ''}
              </div>
            </th>
            <th style={{ whiteSpace: 'nowrap' }}>
              <div className="item" onClick={sortRelatedTransaction.bind(null, 'event_name')}>Event Name
                {tableSortProps.sort_field === 'event_name' ? <i className={`fa ${sortIconsFA[tableSortProps.sort_direction]}`} /> : ''}
              </div>
            </th>
            <th style={{ textAlign: 'center', minWidth: '90px' }} >
              <div className="item" onClick={sortRelatedTransaction.bind(null, 'date_event_filed')}>Event Filed
                {tableSortProps.sort_field === 'date_event_filed' ? <i className={`fa ${sortIconsFA[tableSortProps.sort_direction]}`} /> : ''}
              </div>
            </th>
            <th style={{ textAlign: 'center', minWidth: '90px' }}>
              <div className="item" onClick={sortRelatedTransaction.bind(null, 'date_event_terminated')}>Event Terminated
              {tableSortProps.sort_field === 'date_event_terminated' ? <i className={`fa ${sortIconsFA[tableSortProps.sort_direction]}`} /> : ''}
              </div>
            </th>
          </tr>
        </thead>
        <tbody className="docket-entries-table">
          { itemRows }
        </tbody>
      </table>
    </div>
  );
};

RelatedTransactionEntries.defaultProps = {
  selectedDocketDetailNum: null,
  redactSeqNum: null,
};

RelatedTransactionEntries.propTypes = {
  entries: PropTypes.array.isRequired,
  transactions: PropTypes.any.isRequired,
  getDocketDetails: PropTypes.any.isRequired,
  tableSortProps: PropTypes.any.isRequired,
  buyPdf: PropTypes.any.isRequired,
  case_uuid: PropTypes.any.isRequired,
  sortRelatedTransaction: PropTypes.any.isRequired,
  onPopupClick: PropTypes.func.isRequired,
  selectedDocketDetailNum: PropTypes.number,
  redactSeqNum: PropTypes.any,
};

export default RelatedTransactionEntries;



// WEBPACK FOOTER //
// ./src/components/case/related_transaction/RelatedTransactionEntries.jsx